export default {
  default: {
    formFieldLabels: {
      organizationType: '* Organization Type',
      projectType: '* Project Type',
    },
  },
}
